import * as React from 'react';

interface SectionTextProps {
  description: string;
  topPadding?: string;
}

export const SectionHTMLText = ({ description, topPadding }: SectionTextProps) => (
  <div className={`uitk-type-300 pwa-theme--grey-700 ${topPadding}`} dangerouslySetInnerHTML={{ __html: description }} />
);

SectionHTMLText.displayName = 'SectionHTMLText';

export const SectionPlainText = ({ description, topPadding }: SectionTextProps) => (
  <div className={`uitk-type-300 pwa-theme--grey-700 ${topPadding}`}>{description}</div>
);

SectionPlainText.displayName = 'SectionPlainText';
